import { render, staticRenderFns } from "./unbundleGuide.vue?vue&type=template&id=1c4725bb&scoped=true"
import script from "./unbundleGuide.vue?vue&type=script&lang=js"
export * from "./unbundleGuide.vue?vue&type=script&lang=js"
import style0 from "./unbundleGuide.vue?vue&type=style&index=0&id=1c4725bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4725bb",
  null
  
)

export default component.exports